import { Input } from "@/components/ui/input";

export const UtrInput = ({ value, onChange, testid = "utr-input", required = true }) => (
  <div className="relative">
    <Input
      data-testid={testid}
      inputMode="numeric"
      placeholder="12-digit UTR number"
      value={value}
      required={required}
      onChange={(e) => onChange(e.target.value.replace(/\D/g, "").slice(0, 12))}
      className="pr-14 font-mono tracking-widest"
    />
    <span className={`absolute right-3 top-1/2 -translate-y-1/2 text-xs font-semibold ${value.length === 12 ? "text-emerald-600" : "text-slate-400"}`}>
      {value.length}/12
    </span>
  </div>
);

export const isUtr = (v) => /^\d{12}$/.test(v);
